import { Component } from '@theme/component';
class CollectionRail extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.rail = this.querySelector('[data-collection-rail]');
    if (!this.rail) return;
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.previous = this.querySelector('[data-rail-previous]');
    this.next = this.querySelector('[data-rail-next]');
    this.previous?.addEventListener('click', () => this.step(-1), options);
    this.next?.addEventListener('click', () => this.step(1), options);
    this.rail.addEventListener('pointerdown', this.startDrag, options);
    this.rail.addEventListener('pointermove', this.moveDrag, options);
    this.rail.addEventListener('pointerup', this.endDrag, options);
    this.rail.addEventListener('pointercancel', this.endDrag, options);
    this.rail.addEventListener('lostpointercapture', this.endDrag, options);
    this.rail.addEventListener('dragstart', event => event.preventDefault(), options);
    this.rail.addEventListener('click', event => {
      if (this.suppressClick && event.detail !== 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, { ...options, capture: true });
    this.rail.addEventListener('scroll', this.sync, { passive: true });
    this.resizeObserver = new ResizeObserver(this.sync);
    this.resizeObserver.observe(this.rail);
    this.sync();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.rail?.removeEventListener('scroll', this.sync);
    this.resizeObserver?.disconnect();
    this.controller?.abort();
    clearTimeout(this.clickTimer);
    this.drag = null;
    this.rail?.classList.remove('is-dragging');
  }
  step(direction) {
    const rail = this.rail;
    if (!rail) return;
    const card = rail.querySelector('.ms-collection-nav-card');
    const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
    const distance = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * .8;
    rail.scrollBy({ left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }
  startDrag = event => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    clearTimeout(this.clickTimer);
    this.suppressClick = false;
    this.drag = { id: event.pointerId, x: event.clientX, scroll: this.rail.scrollLeft, moved: false };
  };
  moveDrag = event => {
    const drag = this.drag;
    if (!drag || event.pointerId !== drag.id) return;
    if (event.buttons !== 1) { this.endDrag(event); return; }
    const distance = event.clientX - drag.x;
    if (!drag.moved && Math.abs(distance) < 6) return;
    if (!drag.moved) {
      drag.moved = true;
      this.rail.classList.add('is-dragging');
      this.rail.setPointerCapture(event.pointerId);
    }
    event.preventDefault();
    this.rail.scrollLeft = drag.scroll - distance;
  };
  endDrag = event => {
    const drag = this.drag;
    if (!drag || event.pointerId !== drag.id) return;
    this.drag = null;
    this.suppressClick = drag.moved;
    if (this.rail.hasPointerCapture(event.pointerId)) this.rail.releasePointerCapture(event.pointerId);
    this.rail.classList.remove('is-dragging');
    this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 400);
    this.sync();
  };
  sync = () => {
    const rail = this.rail;
    if (!rail) return;
    const ratio = Math.min(1, rail.clientWidth / rail.scrollWidth);
    this.style.setProperty('--rail-thumb', `${ratio * 100}%`);
    this.style.setProperty('--rail-offset', `${Math.abs(rail.scrollLeft) / rail.clientWidth * 100}%`);
    const max = rail.scrollWidth - rail.clientWidth;
    const offset = Math.abs(rail.scrollLeft);
    const rtl = getComputedStyle(rail).direction === 'rtl';
    if (this.previous) this.previous.disabled = max < 2 || (rtl ? offset >= max - 2 : offset < 2);
    if (this.next) this.next.disabled = max < 2 || (rtl ? offset < 2 : offset >= max - 2);
  };
}
if (!customElements.get('ms-collection-rail')) customElements.define('ms-collection-rail', CollectionRail);
